import styled from "styled-components";

import { windowWidth } from "@styles/global";

// Libraties
import { Autocomplete } from "@libraries/mui";
import { ContractType } from "src/store/graphql/helpers/types.graphql";

const FormContainer = styled.form`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 7px;
  padding-bottom: 20px;

  @media (max-width: ${windowWidth.tablet}) {
    width: 100%;

    ::-webkit-scrollbar {
      width: 1px;
    }
  }

  .MuiAutocomplete-root {
    width: 440px;

    @media (max-width: ${windowWidth.tablet}) {
      width: 100%;
    }
  }
`;

const ContractCardContainer = styled.div`
  margin-top: 20px;
  width: 440px;

  @media (max-width: ${windowWidth.tablet}) {
    width: 100%;
  }
`;

export { FormContainer, ContractCardContainer };
